// ─────────────────────────────────────────────────────────────────────────────
// utils/solutionApiService.ts
// All HTTP/API calls for the ViewSolutionDetails feature.
// Keeping these separate makes them independently mockable and testable.
// ─────────────────────────────────────────────────────────────────────────────

import { ORCHESTRATOR_CONFIG } from '../../../config/orchestratorConfig';
import { httpConstants } from '../../../constants';
import { httpService } from '../../../utility/httpService';
import { buildSyncPayload } from './solutionUtils';

const AGENT_URL_1 = ORCHESTRATOR_CONFIG.ENDPOINTS.AGENT_CLASSIFICATION;
const AGENT_URL_2 = ORCHESTRATOR_CONFIG.ENDPOINTS.AGENT_AI_ENABLEMENT;

/**
 * Calls AGENT_URL_1 (agent classification / data sources sync).
 * Stores a session-storage timestamp keyed by solution ID for later
 * staleness checks.
 */
export const makeDataSourcesSyncCall = async (
  aiSolutionData: any,
  enterpriseTechResponse: any,
  additionalPayload?: any,
  processType?: 'custom' | 'standard' | string
): Promise<any> => {
  const solutionId = String(aiSolutionData?.id || '');
  if (solutionId) {
    sessionStorage.setItem(
      `simulation_sync_agent_updated_at_${solutionId}`,
      new Date().toISOString()
    );
  }

  const payload = buildSyncPayload(
    aiSolutionData,
    enterpriseTechResponse,
    additionalPayload,
    processType
  );

  return httpService<any>(httpConstants.METHOD_TYPE.POST, AGENT_URL_1, payload, undefined, true);
};

/**
 * Calls AGENT_URL_2 (AI enablement sync).
 */
export const makeAiEnablementSyncCall = async (
  aiSolutionData: any,
  enterpriseTechResponse: any,
  additionalPayload?: any,
  processType?: 'custom' | 'standard' | string
): Promise<any> => {
  const payload = buildSyncPayload(
    aiSolutionData,
    enterpriseTechResponse,
    additionalPayload,
    processType
  );

  return httpService<any>(httpConstants.METHOD_TYPE.POST, AGENT_URL_2, payload, undefined, true);
};
